import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTickets = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 33 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.3054 31.8C16.7381 32.1086 17.3307 32.0584 17.7054 31.6813L31.68 17.7053C32.0565 17.3304 32.1067 16.7382 31.7987 16.3053C30.4575 14.418 30.4575 11.8886 31.7987 10.0013C32.1081 9.5683 32.0578 8.97484 31.68 8.59999L25.4 2.31866C25.0247 1.94069 24.4308 1.89044 23.9974 2.19999C22.1103 3.54057 19.5817 3.54057 17.6947 2.19999C17.2616 1.89253 16.6698 1.94269 16.2947 2.31866L2.32003 16.2947C1.94364 16.6695 1.89292 17.2613 2.20003 17.6947C3.54124 19.582 3.54124 22.1113 2.20003 23.9987C1.89101 24.432 1.94184 25.0255 2.32003 25.4L8.60003 31.6813C8.97536 32.0575 9.56789 32.1066 10 31.7973C11.8882 30.4563 14.4183 30.4574 16.3054 31.8Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.0623 7.70522C17.4528 7.31469 18.086 7.31469 18.4765 7.70521L26.2943 15.523C26.6848 15.9135 26.6848 16.5467 26.2943 16.9372L16.9379 26.2936C16.5473 26.6842 15.9142 26.6842 15.5236 26.2936L7.70587 18.4759C7.31534 18.0853 7.31534 17.4522 7.70587 17.0617L17.0623 7.70522Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7693 13.1533L13.1533 17.7693",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.372 17.7053L17.9346 19.1427",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgTickets);
export default ForwardRef;
